import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { ConfirmModalData } from './confirm-modal-data';

@Component({
  selector: 'app-confirm-modal',
  imports: [TranslatePipe, MatIcon, MatIconButton, MatButton, MatDialogActions, MatDialogContent, MatDialogClose],
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.scss'
})
export class ConfirmModalComponent {
  readonly dialogRef = inject(MatDialogRef<ConfirmModalComponent>);
  readonly data = inject<ConfirmModalData>(MAT_DIALOG_DATA);
  title: string = this.data.title;
  description: string = this.data.description;

  protected closeModal() {
    this.dialogRef.close({ continue: false });
  }

  protected continue() {
    return {
      continue: true
    };
  }
}
